import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Button, Card, Input } from '@copilot/ui';
import { Field } from '../components/common/Field';
import * as authApi from '../services/authApi';
import { getUserFriendlyError } from '../utils/errors';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      await authApi.forgotPassword({ email });
      setSubmitted(true);
    } catch (err) {
      setError(getUserFriendlyError(err, 'Unable to connect. Please try again.'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <div className="auth-brand-title">KrishvaQ</div>
          <div className="auth-brand-subtitle">AI Meeting Assistant</div>
        </div>

        <Card interactive>
          <div className="auth-heading">Forgot Password</div>

          {submitted ? (
            <p>
              If an account exists for <strong>{email}</strong>, a password
              reset link has been sent.
            </p>
          ) : (
            <form className="auth-form" onSubmit={handleSubmit}>
              <Field label="Email" htmlFor="forgot-email">
                <Input
                  id="forgot-email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Field>

              {error && <div className="form-alert">{error}</div>}

              <Button type="submit" block disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </form>
          )}
        </Card>

        <div className="auth-footer-link">
          <Link to="/login">Back to Login</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
